/**
 * Height (px) of the fixed Arc top bar. Kept in a standalone module so
 * layout/sidebar styles can import it without pulling the whole top bar
 * component graph (and its page-level imports) into their module chain.
 */
export const TOP_BAR_HEIGHT = 60
